import { AppLocale, DEFAULT_LOCALE } from "./app-locale";
import { getLocale } from "./locale-store";
import { messageCatalogs, type TranslationKey } from "./messages";

export type TranslationParams = Record<string, string | number>;

/**
 * 문자열 사전에서 문구를 조회한다.
 * `{name}` 형태의 자리표시자는 `params` 값으로 치환된다.
 * 선택한 언어에 문구가 없으면 기본 언어(한국어) 문구로 대체한다.
 */
export function translate(
  key: TranslationKey,
  params?: TranslationParams,
  locale: AppLocale = getLocale(),
): string {
  const template = messageCatalogs[locale][key] || messageCatalogs[DEFAULT_LOCALE][key] || key;
  return interpolate(template, params);
}

/**
 * 문구 중간에 React 노드를 넣어야 할 때 사용한다.
 * 자리표시자를 기준으로 앞/뒤 문자열을 반환한다.
 * 예) `translateAround("findPassword.complete.sentTo", "email")` → ["... 이메일을 ", " 로 발송했습니다."]
 */
export function translateAround(
  key: TranslationKey,
  placeholderName: string,
  params?: TranslationParams,
  locale: AppLocale = getLocale(),
): [string, string] {
  const template = messageCatalogs[locale][key] || messageCatalogs[DEFAULT_LOCALE][key] || key;
  const [before, after = ""] = template.split(`{${placeholderName}}`);
  return [interpolate(before, params), interpolate(after, params)];
}

function interpolate(template: string, params?: TranslationParams): string {
  if (!params) return template;

  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}
